import type { ApiClient } from "../../../infrastructure/http/apiClient";
import { ApiClientError } from "../../../infrastructure/http/apiClient";
import type { AuthLoginCredentials, AuthLoginSession } from "../domain/session";

const AUTH_LOGIN_PATH = "/api/v1/auth/login";

export async function loginWithPassword(apiClient: ApiClient, credentials: AuthLoginCredentials): Promise<AuthLoginSession> {
  const response = await apiClient.post<unknown, AuthLoginCredentials>(AUTH_LOGIN_PATH, credentials);

  if (!isAuthLoginSession(response)) {
    throw new ApiClientError("The auth/login response did not match the expected contract.", {
      code: "invalid_response"
    });
  }

  return response;
}

function isAuthLoginSession(value: unknown): value is AuthLoginSession {
  return isRecord(value)
    && typeof value.access_token === "string"
    && typeof value.user_id === "string"
    && typeof value.tenant_id === "string"
    && typeof value.role === "string";
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
